import { render, staticRenderFns } from "./QuillEditorSnow.vue?vue&type=template&id=52e8fe80"
import script from "./QuillEditorSnow.vue?vue&type=script&lang=js"
export * from "./QuillEditorSnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports